import React from "react"
import * as ReactDOMClient from 'react-dom/client';
import { Provider } from "react-redux"
import { startAudioTest } from "../actions/checks"
import SelfMicCheckModal from "../checks/SelfMic"
import { store } from "../data/store"

function renderMicTest(emit) {
    const divEl = document.createElement("div")
    document.body.appendChild(divEl)

    const root = ReactDOMClient.createRoot(divEl)

    const eventHandler = {
        onRegistered: () => {
            console.log("[batchdialer-softphone] registered")
            emit("show")
        },
        onTest: () => {
            console.log("[batchdialer-softphone] disconnected")
            emit("test")
        },
        onFinish: (recommendation, params) => {
            const data = {
                recommendation, params
            }
            emit("finished", data)
        },
        onError: error => {
            console.log("[batchdialer-softphone] error ", error)
            emit("error", error)
        },
    }

    root.render(
        <Provider store={store}>
            <SelfMicCheckModal  eventHandler={eventHandler} />
        </Provider>
    )

    return [divEl, root]
}

export default class SpeedTest{
    events = {
        show: [],
        error: [],
        test: [],
        finished: [],

    }
    container = null
    root = null
    constructor(props) {
        this.emit = this.emit.bind(this)
    }

    on(event, cb) {
        this.events[event].push(cb)
    }

    register() {
        renderMicTest(this.emit)
    }
    startTest() {
        store.dispatch(startAudioTest(true))
    }
    stopTest() {
        store.dispatch(startAudioTest(false))
    }
    pauseTest() {
        store.dispatch(startAudioTest('pause'))
    }
    resumeTest() {
        store.dispatch(startAudioTest('resume'))
    }
    finished() {
        console.log('test Finished')
    }

    emit(event, value) {
        if (!event && event in this.events[event]) {
            throw Error(event + " is unknown event")
        }

        if (!this.events[event].length) {
            // throw Error(`No callback register for ${event}`);
            console.log(`No callback registerd for ${event}`)
        }
        this.events[event].forEach(cb => cb(value))
    }
}



